const UPDATE_NOTIFICATION_LIST = 'luft-promo/notification/UPDATE_NOTIFICATION_LIST';
const MARK_NOTIFICATION_AS_READ = 'luft-promo/notification/MARK_NOTIFICATION_AS_READ';

export const NotificationTypes = {
  UPDATE_NOTIFICATION_LIST,
  MARK_NOTIFICATION_AS_READ,
};
